<script>
/**
 * 查询结果
 */
export default {
  name: 'inqueryResult',
  props: {
    title: { // 自定义标题
      type: String,
      default: '',
      required: false
    },
    isTips: {
      type: Boolean,
      default: false, // 默认关闭
    },
    isExport: { // 是否需要导出按钮
      type: Boolean,
      default: true, // 默认启用
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    export () { // 导出功能
      this.$emit('export')
    }
  },
  render () {
    return (
      <div class="inqueryResult clearfix">
        <label class="title-line"></label>
        <span class="title">{this.title ? this.title : '查询结果'}</span>
        <span class="tips">{this.isTips ? '（会员平台数据仅供业务查询参考，如需法定财务记账凭证，请与共享结算中心联系。）' : ''}</span>
        {this.isExport ? <el-button type="primary" class="export" loading={this.loading} onClick={this.export}>
          {this.loading ? '' : <i class="el-icon-upload2"></i>}
          导出
        </el-button> : ''}
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
.inqueryResult{
  margin: 15px 0; // 与表格的margin保持一致
  height: 32px;
  line-height: 32px;
  .title-line {
    width:4px;
    height:14px;
    background-color:#f8bd47;
    display:inline-block
  }
  .title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #161616;
  }
  .tips{
    font-size: 12px;
    color: #f8bd47;
  }
  .export {
      float: right;
      background-color: rgb(255,255,255);
      color: rgb(96,98,102);
      border-color: rgb(220,223,230);
      height: 32px;
      padding: 0 20px;
      font-size: 15px;
      border-radius: 4px;
      width: 80px;
      i {
        position: relative;
        left: -5px;
        padding-left: 4px;
      }
  }
  .export:active,
  .export:hover {
      background-color: rgb(254,248,237);
      border-color: rgb(253,235,200);
      color: rgb(251, 210, 108)
  }
}
</style>
